import { render, staticRenderFns } from "./FormLayoutV2.vue?vue&type=template&id=3c7e2e4c"
import script from "./FormLayoutV2.vue?vue&type=script&lang=js"
export * from "./FormLayoutV2.vue?vue&type=script&lang=js"
import style0 from "./FormLayoutV2.vue?vue&type=style&index=0&id=3c7e2e4c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports